import script from "./ManageReturn.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageReturn.vue?vue&type=script&setup=true&lang=js"

import "./ManageReturn.vue?vue&type=style&index=0&id=ee02b366&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee02b366"]])

export default __exports__